module.exports = __webpack_public_path__ + "fm.b933332a281ef9c3f3e9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/fm.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/fm.svg
// module chunks = styles